export default class ConfettiParticle {
    public x: number;

    public y: number;

    public r: number;

    public d: number;

    public color: string;

    public tilt: number;

    public tiltAngleIncremental: number;

    public tiltAngle: number;
  
    constructor(W: number, H: number, possibleColors: string[], maxConfettis: number) {
      this.x = Math.random() * W;
      this.y = Math.random() * H - H;
      this.r = Math.floor(Math.random() * (33 - 11 + 1) + 11);
      this.d = Math.random() * maxConfettis + 11;
      this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)];
      this.tilt = Math.floor(Math.random() * 33) - 11;
      this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
      this.tiltAngle = 0;
    }
  
    draw(context: CanvasRenderingContext2D) {
      context.beginPath();
      context.lineWidth = this.r / 2;
      context.strokeStyle = this.color;
      context.moveTo(this.x + this.tilt + this.r / 3, this.y);
      context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
      return context.stroke();
    }
  }
